var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "storeFeedbackApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "nodeList" },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.stepsActive,
                "process-status": "finish ",
                "finish-status": "success",
              },
            },
            _vm._l(_vm.nodeList, function (item, index) {
              return _c("el-step", {
                key: index,
                attrs: { title: item.nodeName },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.isStore
        ? _c(
            "el-tag",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { type: "success" },
            },
            [
              _vm._v(
                "请餐厅伙伴留意：本系统仅针对产品质量方面问题的反馈。非产品质量问题，如物流配送或产品短保等，请联系配送DC或直送供应商。"
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "searchBox" }, [
        _c(
          "div",
          { staticClass: "searchBox_top" },
          [
            _vm.saveSourceCodeBtnShow
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FeedbacksUpdateSourceCode,
                        expression: "FeedbacksUpdateSourceCode",
                      },
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.saveSourceCode },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.save")))]
                )
              : _vm._e(),
            _vm.saveBtnShow
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FeedbacksSave,
                        expression: "FeedbacksSave",
                      },
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.saveStoreFeedback },
                  },
                  [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
                )
              : _vm._e(),
            _vm.saveBtnShowMCD
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FeedbacksMcdSave,
                        expression: "FeedbacksMcdSave",
                      },
                    ],
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.saveStoreFeedbackMCD("save")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.save")))]
                )
              : _vm._e(),
            _vm.submitBtnShow
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FeedbacksSave,
                        expression: "FeedbacksSave",
                      },
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.submitStoreFeedback },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.submit")))]
                )
              : _vm._e(),
            _vm.returnBtnShow
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.FeedbacksFcReturn,
                        expression: "FeedbacksFcReturn",
                      },
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.returnStoreFeedback },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.return")))]
                )
              : _vm._e(),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
              [_vm._v("关闭")]
            ),
            _vm.saveBtnShow
              ? [
                  _c("br"),
                  _c(
                    "label",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#F56C6C",
                        clear: "both",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "feedbackDataForm",
          attrs: {
            model: _vm.feedbackData,
            "label-position": _vm.labelPosition,
            rules: _vm.feedbackRules,
            "label-width": "220px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeFeedback.feedbackNo"),
                        prop: "feedbackNo",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.feedbackData.feedbackNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackData, "feedbackNo", $$v)
                          },
                          expression: "feedbackData.feedbackNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "110px",
                        label: _vm.$t("storeFeedback.reportType"),
                        prop: "reportType",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.feedbackData.reportTypeI18n,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackData, "reportTypeI18n", $$v)
                          },
                          expression: "feedbackData.reportTypeI18n",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.feedbackData.ttFeedbackId != null,
                      expression: "feedbackData.ttFeedbackId != null",
                    },
                  ],
                  attrs: { span: 6 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "110px",
                        label: _vm.$t("storeFeedback.handleUser"),
                        prop: "reportType",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.feedbackData.handleUserName,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackData, "handleUserName", $$v)
                          },
                          expression: "feedbackData.handleUserName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.remarks"),
                        prop: "remark",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: {
                          type: "textarea",
                          maxlength: "300",
                          autosize: "",
                          disabled: _vm.disableEditor,
                        },
                        model: {
                          value: _vm.feedbackData.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackData, "remark", $$v)
                          },
                          expression: "feedbackData.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _vm.feedbackData.suspendReason &&
              _vm.feedbackData.suspendReason != " "
                ? _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.suspendReason"),
                            prop: "suspendReason",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              type: "textarea",
                              maxlength: "300",
                              autosize: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.feedbackData.suspendReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "suspendReason", $$v)
                              },
                              expression: "feedbackData.suspendReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.feedbackData.returnRemark != null,
                  expression: "feedbackData.returnRemark != null",
                },
              ],
            },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "质量反馈中心初检退回原因",
                        prop: "remark",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: {
                          type: "textarea",
                          maxlength: "300",
                          autosize: "",
                          disabled: "",
                        },
                        model: {
                          value: _vm.feedbackData.returnRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackData, "returnRemark", $$v)
                          },
                          expression: "feedbackData.returnRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("餐厅&产品基本信息")])]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.createDate"),
                            prop: "createDate",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.feedbackData.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "createDate", $$v)
                              },
                              expression: "feedbackData.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.creator"),
                            prop: "creator",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.feedbackData.createName,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "createName", $$v)
                              },
                              expression: "feedbackData.createName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.creatorTelephone"),
                            prop: "tel",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              disabled: _vm.disableEditor,
                              oninput:
                                "if(value.length>11)value=value.slice(0,11)",
                            },
                            model: {
                              value: _vm.feedbackData.tel,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "tel", $$v)
                              },
                              expression: "feedbackData.tel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.storeNo"),
                            prop: "storeNo",
                          },
                        },
                        [
                          _vm.isShow
                            ? _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: _vm.disableEditor },
                                on: { change: _vm.changeStore },
                                model: {
                                  value: _vm.feedbackData.storeNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.feedbackData, "storeNo", $$v)
                                  },
                                  expression: "feedbackData.storeNo",
                                },
                              })
                            : _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.disableEditor,
                                    placeholder: _vm.$t("common.sel"),
                                  },
                                  on: { change: _vm.changeStore },
                                  model: {
                                    value: _vm.feedbackData.storeNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.feedbackData, "storeNo", $$v)
                                    },
                                    expression: "feedbackData.storeNo",
                                  },
                                },
                                _vm._l(_vm.storeNoOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.storeName"),
                            prop: "storeName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.feedbackData.storeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "storeName", $$v)
                              },
                              expression: "feedbackData.storeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.city"),
                            prop: "city",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.feedbackData.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "city", $$v)
                              },
                              expression: "feedbackData.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _vm.feedbackData.reportType == "STORE"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.materialCode"),
                                prop: "materialCode",
                              },
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "light",
                                    content:
                                      "请查询DC送货单中的货号（8位数字）",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    attrs: {
                                      disabled:
                                        _vm.disableEditor && !_vm.returnBtnShow,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeMaterialCode()
                                      },
                                    },
                                    model: {
                                      value: _vm.feedbackData.materialCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.feedbackData,
                                          "materialCode",
                                          $$v
                                        )
                                      },
                                      expression: "feedbackData.materialCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.materialCode"),
                                prop: "materialCode",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: {
                                  "suffix-icon": "el-icon-search",
                                  disabled: _vm.disableEditor,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.showSelMaterialDialog =
                                      !_vm.disableEditor
                                  },
                                },
                                model: {
                                  value: _vm.feedbackData.materialCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackData,
                                      "materialCode",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackData.materialCode",
                                },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: _vm.feedbackData.reportType == "STORE",
                            label: _vm.$t("storeFeedback.dcName"),
                            prop: "dcName",
                          },
                        },
                        [
                          _vm.isSUPPLIER
                            ? _c("ic-select", {
                                staticClass: "handle-input",
                                attrs: {
                                  table: "TT_FEEDBACK",
                                  field: "DIRECT_SUPPLIER",
                                  disabled:
                                    _vm.disableEditor && !_vm.returnBtnShow,
                                },
                                model: {
                                  value: _vm.feedbackData.tmDcId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.feedbackData, "tmDcId", $$v)
                                  },
                                  expression: "feedbackData.tmDcId",
                                },
                              })
                            : _c("el-input", {
                                staticClass: "handle-input",
                                attrs: {
                                  "suffix-icon": "el-icon-search",
                                  disabled:
                                    _vm.disableEditor && !_vm.returnBtnShow,
                                },
                                on: {
                                  focus: function ($event) {
                                    return _vm.openDcSelectPage()
                                  },
                                },
                                model: {
                                  value: _vm.feedbackData.dcName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.feedbackData, "dcName", $$v)
                                  },
                                  expression: "feedbackData.dcName",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.materialName"),
                            prop: "materialName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.feedbackData.materialName,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "materialName", $$v)
                              },
                              expression: "feedbackData.materialName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.supplier"),
                            prop: "supplierName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.feedbackData.supplierName,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "supplierName", $$v)
                              },
                              expression: "feedbackData.supplierName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: _vm.feedbackData.reportType == "STORE",
                            label: _vm.$t("storeFeedback.receiveDate"),
                            prop: "receiveDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                              disabled: _vm.disableEditor,
                            },
                            on: {
                              focus: function ($event) {
                                return _vm.selectDataBefore("receiveDate")
                              },
                            },
                            model: {
                              value: _vm.feedbackData.receiveDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "receiveDate", $$v)
                              },
                              expression: "feedbackData.receiveDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: _vm.feedbackData.reportType == "STORE",
                            label: _vm.$t("storeFeedback.productionDate"),
                            prop: "productionDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                              disabled: _vm.disableEditor && !_vm.returnBtnShow,
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.checkRepeatMethod()
                              },
                              focus: function ($event) {
                                return _vm.selectDataBefore("productionDate")
                              },
                            },
                            model: {
                              value: _vm.feedbackData.productionDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackData,
                                  "productionDate",
                                  $$v
                                )
                              },
                              expression: "feedbackData.productionDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.expirationDate"),
                            prop: "expirationDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackData.expirationDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackData,
                                  "expirationDate",
                                  $$v
                                )
                              },
                              expression: "feedbackData.expirationDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.lotNumber"),
                            prop: "lotNumber",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: _vm.disableEditor },
                            model: {
                              value: _vm.feedbackData.lotNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "lotNumber", $$v)
                              },
                              expression: "feedbackData.lotNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.feedbackChannel"),
                            prop: "sourceCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              attrs: {
                                disabled:
                                  _vm.disableEditorSourceCode &&
                                  !_vm.returnBtnShow,
                              },
                              on: { blur: _vm.selectBlurSourceCode },
                              model: {
                                value: _vm.feedbackData.sourceCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.feedbackData, "sourceCode", $$v)
                                },
                                expression: "feedbackData.sourceCode",
                              },
                            },
                            _vm._l(_vm.sourceCodeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.isDirectSale"),
                            prop: "isDirectSale",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticClass: "handle-input",
                            attrs: {
                              clearable: "",
                              table: "TT_FEEDBACK",
                              field: "IS_DIRECT_SALE",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackData.isDirectSale,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "isDirectSale", $$v)
                              },
                              expression: "feedbackData.isDirectSale",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.relatedParties"),
                            prop: "relatedParties",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticClass: "handle-input",
                            attrs: {
                              clearable: "",
                              table: "TT_FEEDBACK",
                              field: "RELATED_PARTIES",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackData.relatedParties,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackData,
                                  "relatedParties",
                                  $$v
                                )
                              },
                              expression: "feedbackData.relatedParties",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.consumeType"),
                            prop: "consumeType",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticClass: "handle-input",
                            attrs: {
                              clearable: "",
                              table: "TT_FEEDBACK",
                              field: "CONSUME_TYPE",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackData.consumeType,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackData, "consumeType", $$v)
                              },
                              expression: "feedbackData.consumeType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.feedbackData.relatedParties == "other",
                      expression: "feedbackData.relatedParties == 'other'",
                    },
                  ],
                  attrs: { gutter: 16 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.relatedPartiesOther"),
                            prop: "relatedPartiesOther",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackData.relatedPartiesOther,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackData,
                                  "relatedPartiesOther",
                                  $$v
                                )
                              },
                              expression: "feedbackData.relatedPartiesOther",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showFcRemarksRow
                ? _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.fcRemarks"),
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: _vm.disableEditorFcRemarks,
                                },
                                model: {
                                  value: _vm.feedbackData.fcRemarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.feedbackData, "fcRemarks", $$v)
                                  },
                                  expression: "feedbackData.fcRemarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "最终责任方" } },
                        [
                          _c("IcSelect", {
                            attrs: {
                              table: "TT_FEEDBACK_REPORT",
                              field: "FINAL_RESPONSIBLE_PARTY",
                              disabled: "",
                            },
                            model: {
                              value: _vm.feedbackData.finalResponsibleParty,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackData,
                                  "finalResponsibleParty",
                                  $$v
                                )
                              },
                              expression: "feedbackData.finalResponsibleParty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showFcRemarksRow
                ? _c(
                    "el-row",
                    { attrs: { gutter: 16, type: "flex", justify: "center" } },
                    [
                      _vm.saveFcRemarksBtnShow
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.saveFcRemarks },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.save")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("投诉基本信息")])]
          ),
          _c(
            "el-form",
            {
              ref: "feedbackComplaintDataForm",
              attrs: {
                model: _vm.feedbackComplaintData,
                "label-position": _vm.labelPosition,
                rules: _vm.feedbackComplaintRules,
                "label-width": "160px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "外包装数量", prop: "outerPackNum" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "handle-input unit__uom",
                              attrs: {
                                type: "number",
                                disabled: _vm.disableEditor,
                                onkeyup:
                                  "value=value.replace(/^0+|\\\\D/g, '').slice(0, 10)",
                              },
                              model: {
                                value: _vm.feedbackComplaintData.outerPackNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.feedbackComplaintData,
                                    "outerPackNum",
                                    $$v
                                  )
                                },
                                expression:
                                  "feedbackComplaintData.outerPackNum",
                              },
                            },
                            [
                              _vm.outerPackUnitValue
                                ? _c("template", { slot: "append" }, [
                                    _vm._v(_vm._s(_vm.outerPackUnitValue)),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "内包装数量",
                            prop: "innerPackNum",
                            "label-width": "150px",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "handle-input unit__uom",
                              attrs: {
                                type: "number",
                                disabled:
                                  _vm.disableEditor || _vm.disableInnerPack,
                                onkeyup:
                                  "value=value.replace(/^0+|\\\\D/g, '').slice(0, 10)",
                              },
                              model: {
                                value: _vm.feedbackComplaintData.innerPackNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.feedbackComplaintData,
                                    "innerPackNum",
                                    $$v
                                  )
                                },
                                expression:
                                  "feedbackComplaintData.innerPackNum",
                              },
                            },
                            [
                              _vm.innerPackUnitValue
                                ? _c("template", { slot: "append" }, [
                                    _vm._v(_vm._s(_vm.innerPackUnitValue)),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "散货数量",
                            prop: "bulkNum",
                            "label-width": "140px",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "handle-input unit__uom",
                              attrs: {
                                type: "number",
                                disabled: _vm.disableEditor,
                                onkeyup:
                                  "value=value.replace(/^0+|\\\\D/g, '').slice(0, 10)",
                              },
                              model: {
                                value: _vm.feedbackComplaintData.bulkNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.feedbackComplaintData,
                                    "bulkNum",
                                    $$v
                                  )
                                },
                                expression: "feedbackComplaintData.bulkNum",
                              },
                            },
                            [
                              _vm.feedbackComplaintData.bulkUnit
                                ? _c("template", { slot: "append" }, [
                                    _vm._v(
                                      _vm._s(_vm.feedbackComplaintData.bulkUnit)
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.source"),
                            prop: "source",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticClass: "handle-input",
                            attrs: {
                              clearable: "",
                              table: "TT_FEEDBACK_COMPLAINT",
                              field: "SOURCE",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackComplaintData.source,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackComplaintData,
                                  "source",
                                  $$v
                                )
                              },
                              expression: "feedbackComplaintData.source",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: _vm.feedbackData.reportType == "STORE",
                            label: _vm.$t("storeFeedback.productStatus"),
                            prop: "productStatus",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticClass: "handle-input",
                            attrs: {
                              placeholder: "NA",
                              clearable: "",
                              table: "TT_FEEDBACK_COMPLAINT",
                              field: "PRODUCT_STATUS",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackComplaintData.productStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackComplaintData,
                                  "productStatus",
                                  $$v
                                )
                              },
                              expression: "feedbackComplaintData.productStatus",
                            },
                          }),
                          _c("div", { staticClass: "ccTip" }, [
                            _vm._v(
                              "如涉及异物,务请将其保管在餐厅供后续调查使用"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.ccStore"),
                            prop: "cc",
                            rules: _vm.feedbackComplaintRules.cc,
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              disabled: _vm.disableEditor,
                              placeholder: "多个邮箱用,或;分割",
                            },
                            on: {
                              blur: function ($event) {
                                _vm.feedbackComplaintData.cc =
                                  _vm.feedbackComplaintData.cc.replace(
                                    /\s+/g,
                                    ""
                                  )
                              },
                            },
                            model: {
                              value: _vm.feedbackComplaintData.cc,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackComplaintData, "cc", $$v)
                              },
                              expression: "feedbackComplaintData.cc",
                            },
                          }),
                          _c("div", { staticClass: "ccTip" }, [
                            _vm._v(
                              "质量反馈单需同时抄送所属的OC、OM、QSC/EHSS经理"
                            ),
                            _c("br"),
                            _vm._v("若有多个邮箱，请用逗号或分号区分"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: _vm.feedbackData.reportType == "STORE",
                            label: _vm.$t("storeFeedback.haveCompensated"),
                            prop: "haveCompensated",
                          },
                        },
                        [
                          _c("ic-select", {
                            staticClass: "handle-input",
                            attrs: {
                              placeholder: "NA",
                              clearable: "",
                              table: "TT_FEEDBACK_COMPLAINT",
                              field: "HAVE_COMPENSATED",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackComplaintData.haveCompensated,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackComplaintData,
                                  "haveCompensated",
                                  $$v
                                )
                              },
                              expression:
                                "feedbackComplaintData.haveCompensated",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.compensateInfo"),
                            prop: "compensateInfo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              type: "textarea",
                              maxlength: "1000",
                              autosize: "",
                              disabled: _vm.compensateInfoDisable(
                                _vm.disableEditor
                              ),
                            },
                            model: {
                              value: _vm.feedbackComplaintData.compensateInfo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackComplaintData,
                                  "compensateInfo",
                                  $$v
                                )
                              },
                              expression:
                                "feedbackComplaintData.compensateInfo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.remarks"),
                            prop: "remark",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              type: "textarea",
                              maxlength: "1000",
                              autosize: "",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackComplaintData.remark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackComplaintData,
                                  "remark",
                                  $$v
                                )
                              },
                              expression: "feedbackComplaintData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", {
                        attrs: {
                          label: _vm.$t("storeFeedback.describeProblem"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.description"),
                            prop: "description",
                            rules:
                              _vm.feedbackData.reportType == "STORE"
                                ? _vm.feedbackComplaintRules.description
                                : _vm.feedbackComplaintRules.description2,
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "1000",
                              autosize: "",
                              disabled: _vm.disableEditor,
                            },
                            model: {
                              value: _vm.feedbackComplaintData.description,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackComplaintData,
                                  "description",
                                  $$v
                                )
                              },
                              expression: "feedbackComplaintData.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("common.attachment") } },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "table",
                              attrs: {
                                data: _vm.detailDocfileList,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                  "min-width": "130px",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              !_vm.disableEditor
                                ? _c("el-table-column", {
                                    attrs: {
                                      "show-overflow-tooltip": "",
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.detailDocfileList
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3295394773
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          !_vm.disableEditor
                            ? _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.uploadConfirm,
                                    "on-remove": _vm.detailDocfileRemove,
                                    multiple: "",
                                    "before-upload": _vm.BeforeDetailDoc,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item boxPhotoTip",
                          attrs: {
                            effect: "light",
                            content:
                              "【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】",
                            placement: "top-start",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                required: _vm.reportType == "STORE",
                                label: _vm.$t("storeFeedback.boxPhoto"),
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "boxPhotoRef",
                                  class: { hide: _vm.disableEditor },
                                  attrs: {
                                    accept:
                                      ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                                    disabled: _vm.disableEditor,
                                    multiple: "",
                                    "list-type": "picture-card",
                                    action: "upload",
                                    "file-list": _vm.boxPhotofileList,
                                    "before-upload": _vm.beforeBoxPhoto,
                                    "http-request": _vm.boxPhotoRead,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "file",
                                      fn: function ({ file }) {
                                        return _c(
                                          "div",
                                          { staticStyle: { height: "100%" } },
                                          [
                                            _c("img", {
                                              attrs: {
                                                width: "100%",
                                                height: "100%",
                                                src: file.url,
                                                alt: "",
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-actions",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-preview",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleBoxPhotoPreview(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-zoom-in",
                                                    }),
                                                  ]
                                                ),
                                                file.tmDocumentId
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-upload-list__item-delete",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadFile(
                                                              file
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-download",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                !_vm.disableEditor
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-upload-list__item-delete",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.boxPhotofileRemove(
                                                              file
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-delete",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      },
                                    },
                                  ]),
                                },
                                [_c("i", { staticClass: "el-icon-plus" })]
                              ),
                              _c(
                                "el-dialog",
                                {
                                  staticClass: "enlargePhoto",
                                  attrs: { visible: _vm.boxPhotoDialogVisible },
                                  on: {
                                    "update:visible": function ($event) {
                                      _vm.boxPhotoDialogVisible = $event
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      width: "100%",
                                      src: _vm.boxPhotoImageUrl,
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: _vm.reportType == "STORE",
                            label: _vm.$t("storeFeedback.problemProductPhoto"),
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "problemProductPhotoRef",
                              class: { hide: _vm.disableEditor },
                              attrs: {
                                accept:
                                  ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                                disabled: _vm.disableEditor,
                                multiple: "",
                                "list-type": "picture-card",
                                action: "upload",
                                "file-list": _vm.problemProductPhotoList,
                                "before-upload": _vm.beforeProblemProductPhoto,
                                "http-request": _vm.problemProductPhotoRead,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function ({ file }) {
                                    return _c(
                                      "div",
                                      { staticStyle: { height: "100%" } },
                                      [
                                        _c("img", {
                                          attrs: {
                                            width: "100%",
                                            height: "100%",
                                            src: file.url,
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-preview",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleProblemProductPreview(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-zoom-in",
                                                }),
                                              ]
                                            ),
                                            file.tmDocumentId
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadFile(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-download",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.disableEditor
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.problemProductPhotRemove(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  },
                                },
                              ]),
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _c(
                            "el-dialog",
                            {
                              staticClass: "enlargePhoto",
                              attrs: {
                                visible: _vm.problemProductDialogVisible,
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.problemProductDialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.problemProductImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.otherPhotos"),
                            prop: "otherPhotos",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "otherPhotosRef",
                              class: { hide: _vm.disableEditor },
                              attrs: {
                                accept:
                                  ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                                disabled: _vm.disableEditor,
                                "list-type": "picture-card",
                                action: "upload",
                                "file-list": _vm.otherPhotosList,
                                multiple: "",
                                "before-upload": _vm.beforeOtherPhoto,
                                "http-request": _vm.otherPhotosRead,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function ({ file }) {
                                    return _c(
                                      "div",
                                      { staticStyle: { height: "100%" } },
                                      [
                                        _c("img", {
                                          attrs: {
                                            width: "100%",
                                            height: "100%",
                                            src: file.url,
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-preview",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleOtherPhotosPreview(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-zoom-in",
                                                }),
                                              ]
                                            ),
                                            file.tmDocumentId
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadFile(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-download",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.disableEditor
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.otherPhotosRemove(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  },
                                },
                              ]),
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _c(
                            "el-dialog",
                            {
                              staticClass: "enlargePhoto",
                              attrs: { visible: _vm.otherPhotosDialogVisible },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.otherPhotosDialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.otherPhotosImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.photosDescription"),
                            prop: "photosDescription",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "1000",
                              autosize: "",
                              placeholder: "",
                              disabled: _vm.disableEditor,
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.feedbackComplaintData.photosDescription
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showFirstCheck
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("问题初检信息")])]
              ),
              _c(
                "el-form",
                {
                  ref: "feedbackFirstCheckDataForm",
                  attrs: {
                    model: _vm.feedbackFirstCheckData,
                    "label-position": _vm.labelPosition,
                    rules: _vm.feedbackFirstCheckRules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.complaintType1"),
                                prop: "type1",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  attrs: {
                                    disabled: _vm.disableEditorFirstCheckMcd,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeType1()
                                    },
                                  },
                                  model: {
                                    value: _vm.feedbackFirstCheckData.type1,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.feedbackFirstCheckData,
                                        "type1",
                                        $$v
                                      )
                                    },
                                    expression: "feedbackFirstCheckData.type1",
                                  },
                                },
                                _vm._l(_vm.type1List, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseValue,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.complaintType2"),
                                prop: "type2",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  attrs: {
                                    filterable: "",
                                    "allow-create": "",
                                    disabled: _vm.disableEditorFirstCheckMcd,
                                  },
                                  on: {
                                    "": function ($event) {},
                                    blur: _vm.selectBlurType2,
                                    change: function ($event) {
                                      _vm.changeType2(), _vm.checkRepeatMethod()
                                    },
                                  },
                                  model: {
                                    value: _vm.feedbackFirstCheckData.type2,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.feedbackFirstCheckData,
                                        "type2",
                                        $$v
                                      )
                                    },
                                    expression: "feedbackFirstCheckData.type2",
                                  },
                                },
                                _vm._l(_vm.type2List, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseValue,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.complaintType3"),
                                prop: "type3",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  attrs: {
                                    filterable: "",
                                    "allow-create": "",
                                    disabled: _vm.disableEditorFirstCheckMcd,
                                  },
                                  on: { blur: _vm.selectBlurType3 },
                                  model: {
                                    value: _vm.feedbackFirstCheckData.type3,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.feedbackFirstCheckData,
                                        "type3",
                                        $$v
                                      )
                                    },
                                    expression: "feedbackFirstCheckData.type3",
                                  },
                                },
                                _vm._l(_vm.type3List, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseValue,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.problemLevel"),
                                prop: "problemLevel",
                              },
                            },
                            [
                              _c("ic-select", {
                                staticClass: "handle-input",
                                attrs: {
                                  clearable: "",
                                  table: "TT_FEEDBACK_FIRST_CHECK",
                                  field: "PROBLEM_LEVEL",
                                  disabled: _vm.disableEditorFirstCheckMcd,
                                },
                                on: { change: _vm.changeProblemLevel },
                                model: {
                                  value:
                                    _vm.feedbackFirstCheckData.problemLevel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackFirstCheckData,
                                      "problemLevel",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "feedbackFirstCheckData.problemLevel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.deadline"),
                                prop: "deadlineValue",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value:
                                    _vm.feedbackFirstCheckData.deadlineValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackFirstCheckData,
                                      "deadlineValue",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "feedbackFirstCheckData.deadlineValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.isRepeat"),
                                prop: "isRepeat",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.feedbackFirstCheckData.isRepeat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackFirstCheckData,
                                      "isRepeat",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackFirstCheckData.isRepeat",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.isLto"),
                                prop: "isLto",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "handle-input",
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled: _vm.disableEditorFirstCheck,
                                  },
                                  model: {
                                    value: _vm.feedbackFirstCheckData.isLto,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.feedbackFirstCheckData,
                                        "isLto",
                                        $$v
                                      )
                                    },
                                    expression: "feedbackFirstCheckData.isLto",
                                  },
                                },
                                _vm._l(_vm.isLtoOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.relateType"),
                                prop: "relateType",
                              },
                            },
                            [
                              _c("ic-select", {
                                staticClass: "handle-input",
                                attrs: {
                                  clearable: "",
                                  table: "TT_FEEDBACK_FIRST_CHECK",
                                  field: "RELATE_TYPE",
                                  disabled: _vm.disableEditorFirstCheckMcd,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeRelateType()
                                  },
                                },
                                model: {
                                  value: _vm.feedbackFirstCheckData.relateType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackFirstCheckData,
                                      "relateType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "feedbackFirstCheckData.relateType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.dcName"),
                                prop: "firstCheckDcName",
                              },
                            },
                            [
                              _vm.isSUPPLIER
                                ? _c("ic-select", {
                                    staticClass: "handle-input",
                                    attrs: {
                                      table: "TT_FEEDBACK",
                                      field: "DIRECT_SUPPLIER",
                                      disabled: _vm.disableEditorFirstCheckMcd,
                                    },
                                    on: { change: _vm.firstCheckDcName },
                                    model: {
                                      value:
                                        _vm.feedbackFirstCheckData
                                          .firstCheckDcName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.feedbackFirstCheckData,
                                          "firstCheckDcName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "feedbackFirstCheckData.firstCheckDcName",
                                    },
                                  })
                                : _c("el-input", {
                                    staticClass: "handle-input",
                                    attrs: {
                                      "suffix-icon": "el-icon-search",
                                      disabled: _vm.disableEditorFirstCheckMcd,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.openFirstCheckDcSelectPage()
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.feedbackFirstCheckData
                                          .firstCheckDcName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.feedbackFirstCheckData,
                                          "firstCheckDcName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "feedbackFirstCheckData.firstCheckDcName",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.cc"),
                                prop: "cc",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: {
                                  disabled: _vm.disableEditorFirstCheckMcd,
                                },
                                on: {
                                  blur: function ($event) {
                                    _vm.feedbackFirstCheckData.cc =
                                      _vm.feedbackFirstCheckData.cc.replace(
                                        /\s+/g,
                                        ""
                                      )
                                  },
                                },
                                model: {
                                  value: _vm.feedbackFirstCheckData.cc,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackFirstCheckData,
                                      "cc",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackFirstCheckData.cc",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.mailContent"),
                                prop: "mailContent",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "1000",
                                  placeholder: "",
                                  autosize: { minRows: 5 },
                                  disabled: _vm.disableEditorFirstCheck,
                                },
                                model: {
                                  value: _vm.feedbackFirstCheckData.mailContent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackFirstCheckData,
                                      "mailContent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "feedbackFirstCheckData.mailContent",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcDialog = $event
            },
          },
        },
        [
          _c("SelDc", {
            ref: "selectDcRef",
            attrs: { multipleSelectionFlag: false, showStatus: false },
            on: { subCallMethod: _vm.selectDcMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _c("SelSupplier", {
            attrs: { multipleSelectionFlag: false, showStatus: false },
            on: { subCallMethod: _vm.selectSupplierMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFirstCheckSelDcDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFirstCheckSelDcDialog = $event
            },
          },
        },
        [
          _c("SelDc", {
            ref: "selectDcRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectFirstCheckDcMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFirstCheckSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFirstCheckSelSupplierDialog = $event
            },
          },
        },
        [
          _c("SelSupplier", {
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectFirstCheckSupplierMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showCqsChangeReasonDialog, width: "800px" },
          on: {
            "update:visible": function ($event) {
              _vm.showCqsChangeReasonDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "form_border",
              attrs: {
                "label-position": _vm.labelPosition,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: "",
                            label: "CQS变更原因",
                            placeholder: "",
                            prop: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              rows: "3",
                              type: "textarea",
                              maxlength: "100",
                            },
                            model: {
                              value: _vm.cqsChange.cqsChangeRemarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.cqsChange, "cqsChangeRemarks", $$v)
                              },
                              expression: "cqsChange.cqsChangeRemarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "60px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveStoreFeedbackMCD("submit")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showCqsChangeReasonDialog = false
                      _vm.cqsChange.cqsChangeRemarks = ""
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showCqsChangeReasonDialog1, width: "800px" },
          on: {
            "update:visible": function ($event) {
              _vm.showCqsChangeReasonDialog1 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "form_border",
              attrs: {
                "label-position": _vm.labelPosition,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            required: "",
                            label: "CQS变更原因",
                            placeholder: "",
                            prop: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: {
                              rows: "3",
                              type: "textarea",
                              maxlength: "100",
                            },
                            model: {
                              value: _vm.cqsChange1.cqsChangeRemarks,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cqsChange1,
                                  "cqsChangeRemarks",
                                  $$v
                                )
                              },
                              expression: "cqsChange1.cqsChangeRemarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "60px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.saveSourceCode },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showCqsChangeReasonDialog1 = false
                      _vm.cqsChange1.cqsChangeRemarks = ""
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelMaterialDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelMaterialDialog = $event
            },
          },
        },
        [
          _c("SelMaterial", {
            ref: "selectMaterialRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectMaterialMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "邮件发送提醒",
            visible: _vm.emailDialogVisible,
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.emailDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", [
                _c("p", [
                  _vm._v(
                    "当前问题一周内已出现至少三次，属于重复投诉，请选择是否需要发送提醒邮件？"
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c("el-col", { attrs: { span: 3 } }, [_vm._v("重复邮件")]),
              _c(
                "el-col",
                { attrs: { span: 19 } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isSendRepeatEmail,
                        callback: function ($$v) {
                          _vm.isSendRepeatEmail = $$v
                        },
                        expression: "isSendRepeatEmail",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "Y" } }, [
                        _vm._v("发送"),
                      ]),
                      _c("el-radio", { attrs: { label: "N" } }, [
                        _vm._v("不发送"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c("el-col", { attrs: { span: 3 } }, [_vm._v("邮件通知范围")]),
              _c(
                "el-col",
                { attrs: { span: 19 } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.isUpgradeLevel,
                        callback: function ($$v) {
                          _vm.isUpgradeLevel = $$v
                        },
                        expression: "isUpgradeLevel",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "Y" } }, [
                        _vm._v("A类"),
                      ]),
                      _c("el-radio", { attrs: { label: "N" } }, [
                        _vm._v("非A类"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.isSend(
                        _vm.isSendRepeatEmail,
                        _vm.isUpgradeLevel
                      )
                    },
                  },
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.emailClose } },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }